import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import themesService from "../../services/themesService";

// Queries
export const useGetTheme = (themeID, queryOptions = {}) => {
  return useQuery(
    ["themes", themeID],
    () => themesService.get(themeID),
    queryOptions
  );
};

export const useGetThemeTemplates = (themeID, queryOptions = {}) => {
  return useQuery(
    ["themes", themeID, "templates"],
    () => themesService.getTemplates(themeID),
    queryOptions
  );
};

export const useGetThemes = (queryOptions = {}) => {
  return useQuery(["themes"], () => themesService.index(), queryOptions);
};

// Mutations
export const useUpdateTheme = (themeID, mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    (themeParams) => themesService.update(themeID, themeParams),
    {
      ...mutationOptions,
      onSuccess: (data) => {
        queryClient.setQueryData(["themes", themeID], data);
        mutationOptions.onSuccess(data);
      },
    }
  );
};

export const useUpdateThemeTemplates = (themeID, mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    (templateParams) => themesService.updateTemplates(themeID, templateParams),
    {
      ...mutationOptions,
      onSuccess: (data) => {
        queryClient.setQueryData(["themes", themeID, "templates"], data);
        mutationOptions.onSuccess(data);
      },
    }
  );
};

export const useGetThemeLanguage = (themeID, queryOptions = {}) => {
  return useQuery(
    ["themes", themeID, "language"],
    () => themesService.getLanguage(themeID),
    queryOptions
  );
};

export const useUpdateThemeLanguage = (themeID, mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    (themeParams) => themesService.updateLanguage(themeID, themeParams),
    {
      ...mutationOptions,
      onSuccess: (data) => {
        queryClient.setQueryData(["themes", themeID, "language"], data);
        mutationOptions.onSuccess(data);
      },
    }
  );
};

export const useGetThemeSettings = (themeID, queryOptions = {}) => {
  return useQuery(
    ["themes", themeID, "settings"],
    () => themesService.getSettings(themeID),
    queryOptions
  );
};
export const useUpdateThemeSettings = (themeID, mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    (themeSettings) => themesService.updateSettings(themeID, themeSettings),
    {
      ...mutationOptions,
      onSuccess: (data) => {
        queryClient.setQueryData(["themes", themeID, "settings"], data);
        mutationOptions.onSuccess(data);
      },
    }
  );
};
